import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { i18n } from "@/lib/i18n";
import { appShellTitle } from "@/lib/seo/head";
import { useCartStore } from "@/stores/useCartStore";

// Stripe returns here after a successful hosted-Checkout payment
// (`success_url`). The order is flipped to `paid` asynchronously by the
// webhook, not by this page — so the tracer just confirms and points home.
// Stripe appends `?session_id=…`; unused this slice.
//
// Screen transition (ADR-0052): success gets the uniform full-page root cross-fade like
// every checkout boundary — no element morph. The status truth stays with the
// email/webhook (paid flips asynchronously via the webhook, not this page).
function CheckoutSuccess() {
  const { t } = useTranslation("orders");
  // Payment succeeded — the Cart has done its job and now hands off to the Order view
  // (ADR-0054 §2 "cleared on payment success"). Clear it so the paid products don't
  // linger and a later "create" CTA starts fresh.
  useEffect(() => {
    useCartStore.getState().clear();
  }, []);
  return (
    <section className="mx-auto flex max-w-md flex-col items-center gap-6 px-6 py-16 text-center">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{t("checkout.success.title")}</h1>
        <p className="mt-2 text-balance text-sm text-foreground/70">{t("checkout.success.body")}</p>
      </div>
      <Button asChild size="lg" className="min-h-13 rounded-full px-8 text-base font-semibold">
        <Link to="/">{t("checkout.success.back")}</Link>
      </Button>
    </section>
  );
}

export const Route = createFileRoute("/checkout/success")({
  head: () => ({ meta: [{ title: appShellTitle(i18n.t("shells.checkoutSuccess")) }] }),
  component: CheckoutSuccess,
});
